import styles from './AirwayCollapse.module.css';

export const AirwayCollapse = () => (
  <figure className={styles.figure} aria-label="Airway cross-section showing an apnea event">
    <div className={styles.stage}>
      <svg viewBox="0 0 280 220" className={styles.svg} aria-hidden="true">
        <text x="140" y="18" textAnchor="middle" className={styles.topLabel}>
          AIRWAY · CROSS-SECTION
        </text>

        <g className={styles.wallLeft}>
          <path d="M64 38 Q92 60 92 110 Q92 160 64 182 L64 38 Z" fill="var(--osa-tissue-fill)" />
          <path
            d="M64 38 Q92 60 92 110 Q92 160 64 182"
            fill="none"
            stroke="var(--osa-tissue-stroke)"
            strokeWidth="1.4"
          />
        </g>

        <g className={styles.wallRight}>
          <path d="M216 38 Q188 60 188 110 Q188 160 216 182 L216 38 Z" fill="var(--osa-tissue-fill)" />
          <path
            d="M216 38 Q188 60 188 110 Q188 160 216 182"
            fill="none"
            stroke="var(--osa-tissue-stroke)"
            strokeWidth="1.4"
          />
        </g>

        <g className={styles.airflow}>
          {[44, 64, 84, 104, 124, 144, 164].map((y, i) => (
            <line
              key={y}
              x1="140"
              y1={y}
              x2="140"
              y2={y + 14}
              stroke="var(--osa-accent-healthy)"
              strokeWidth="2.2"
              strokeLinecap="round"
              opacity={1 - i * 0.1}
            />
          ))}
        </g>

        <g className={styles.alarmMarker}>
          <circle
            cx="140"
            cy="110"
            r="14"
            fill="none"
            stroke="var(--osa-accent-alarm)"
            strokeWidth="1.4"
            opacity="0.5"
          />
          <circle cx="140" cy="110" r="7" fill="none" stroke="var(--osa-accent-alarm)" strokeWidth="1.6" />
          <circle cx="140" cy="110" r="2.5" fill="var(--osa-accent-alarm)" />
        </g>

        <g>
          <text
            x="140"
            y="206"
            textAnchor="middle"
            className={`${styles.statusLabel} ${styles.labelBreathing}`}
            fill="var(--osa-accent-healthy)"
          >
            BREATHING
          </text>
          <text
            x="140"
            y="206"
            textAnchor="middle"
            className={`${styles.statusLabel} ${styles.labelEvent}`}
            fill="var(--osa-accent-alarm)"
          >
            APNEA EVENT
          </text>
          <text
            x="140"
            y="206"
            textAnchor="middle"
            className={`${styles.statusLabel} ${styles.labelBreathing2}`}
            fill="var(--osa-accent-healthy)"
          >
            BREATHING
          </text>
        </g>
      </svg>
    </div>
  </figure>
);

export default AirwayCollapse;
